/**
 * État d'affichage du CGForm legacy ouvert avec `?registrationId=`.
 *
 * Avant (sprint du 07/10/2026, démo de François sur l'agence Besançon) : dès
 * que `GET /api/cg/:id` ne rendait pas de dossier (token Firebase expiré →
 * 401, dossier supprimé → `null`, 5xx), le formulaire se rendait quand même
 * et lisait `cgData.BuyerPlaceOfBirth` sur `null` : page « Oups » sans aucune
 * trace Sentry. Ce helper isole la décision pour la tester.
 */
export type CgFormLoadState = 'new' | 'loading' | 'missing' | 'ready';

export const cgFormLoadState = (args: {
  registrationIdParam: string | null;
  isLoading: boolean;
  isError: boolean;
  data: unknown;
}): CgFormLoadState => {
  if (!args.registrationIdParam) return 'new';
  if (args.isLoading) return 'loading';
  if (args.isError || args.data == null) return 'missing';
  return 'ready';
};
